export default "__VITE_ASSET__C4DU_JGr__"